import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { Employee } from "./Employee.model";
import { PointOfService } from "./PointOfService.model";
import { Translation } from "./navigation-entities/Translation.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";

@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'BuzzerConfig'
})
export class BuzzerConfig extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [] })
  show!: boolean;

  fK_Image?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Employee!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  numero?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  startDate?: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  endDate?: Date;

  /// Statut : 0 = Inactive, 1 = Active (voir BuzzerStatus)
  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  status!: number;

  @NestedProperty({ TargetType: FSTREAM_Image })
  image?: FSTREAM_Image;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  selectedPK_Employee?: string[];

  /// Traductions du titre (TypeDeTraduction = 1 = Title)
  @NavigationProperty({ TargetType: Translation })
  subjectTranslations?: Translation[];

  /// Traductions du contenu (TypeDeTraduction = 2 = Description)
  @NavigationProperty({ TargetType: Translation })
  bodyTranslations?: Translation[];

  GetType(): IEntityMetaData {
    return BuzzerConfig.getMetaData();
  }
}
